export default String.raw`
.wishlist-container,
.wishlist-list {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-bottom: 24px;

    &__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        font-size: 24px;
        font-weight: 500;
        line-height: 32px;
        padding-bottom: 24px;
        gap: 16px;

        .primary-action-button {
            width: max-content;
            flex-shrink: 0;
        }

        .title {
            margin-right: 60px;
            word-break: break-all;
        }
    }
}

.wishlist {
    &__table-container {
        white-space: nowrap;
        position: relative;
        min-height: 40px;

        table {
            border-collapse: separate;
            border-spacing: 0 16px;
            width: 100%;
        }

        .wishlist-item-container {
            cursor: pointer;
            border: 1px solid $lightBorderColor;
            min-height: 94px;
            padding: 15px 25px;
            display: grid;
            grid-template-columns: 1fr max-content max-content 440px max-content;
            align-items: center;
            column-gap: 42px;
            border-radius: 5px;
            font-style: normal;
            font-weight: 500;
            line-height: 20px;

            &:hover,
            &:focus-within {
                box-shadow: 0 3px 12px 0 $gridAndListHoverShadowColor;
                
                .wishlist-delete-button {
                    visibility: visible;
                }
            }
        
            & + .wishlist-item-container {
                margin-top: 20px;
            }
            .wishlist-name {
                overflow: hidden;
                text-overflow: ellipsis;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                font-size: 16px;
            }
            .wishlist-double-rows {
                font-size: 14px;
                div:first-child {
                color: #959595;
                }
                & + .wishlist-double-rows {
                margin-left: 33px;
                }
                
                display: flex;
                flex-direction: column;
                row-gap: 8px;
                line-height: 20px;
            }
            .wishlist-products-images-container {
                display: flex;
                .item-container {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 56px;
                height: 56px;
                border-radius: 5px;
                img {
                    max-width: 100%;
                    max-height: 100%;
                }
                & + .item-container {
                    margin-left: 10px
                }
                }
                .only-small-mobile-show-element {
                display: none;
                }
            }

            .wishlist-delete-button {
                visibility: hidden;
            }
        }
    }
}

.wishlist-select {
    width: 160px;
    margin: 0;
}

@media screen and (max-width: 1279px) {
    .wishlist {
        &__table-container {
            .wishlist-item-container {
                display: flex;
                flex-wrap: wrap;
                column-gap: unset;
                row-gap: 15px;
                font-size: 14px;
                padding: 15px;
            
                & + .wishlist-item-container {
                    margin-top: 15px;
                }
            
                .wishlist-name {
                    width: calc(100% - 50px);
                    order: 1;
                }

                .wishlist-double-rows {
                    width: 50%;
                    align-self: flex-end;
                    font-size: 12px;
                    &:first-of-type {
                        order: 3;
                    }
                    &:last-of-type {
                        order: 4;
                    }
                    & + .wishlist-double-rows {
                        margin-left: unset;
                    }
                }

                .wishlist-products-images-container {
                    order: 5;
                    width: 100%;

                    .item-container {
                        width: 42px;
                        height: 42px;
                    }
                }
            
                td:nth-child(2) {
                    order: 3;
                }

                td:nth-child(3) {
                    order: 4;
                }
            
                td:last-of-type {
                    order: 2;
                    margin-left: 14px;
                }
            }
        }
    }
}

.new-wishlist {
    padding: 0;

    .primary-action-button {
        width: auto !important;
    }
}
`